wp.hooks.addFilter(
	'editor.BlockEdit',
	'pwd/gallery-link-toggle',
	(BlockEdit) => (props) => {
		if (props.name !== 'core/gallery') return wp.element.createElement(BlockEdit, props);

		const { Fragment, useState } = wp.element;
		const { InspectorControls } = wp.blockEditor;
		const { PanelBody, ToggleControl } = wp.components;

		const isLinked = props.attributes.linkTo === 'media';

		return (
			wp.element.createElement(Fragment, null,
				wp.element.createElement(BlockEdit, props),
				wp.element.createElement(InspectorControls, null,
					wp.element.createElement(PanelBody, { title: 'Lightbox Settings', initialOpen: true },
						wp.element.createElement(ToggleControl, {
							label: 'Gallery images all open in lightbox',
							checked: isLinked,
							onChange: (value) => {
								props.setAttributes({ linkTo: value ? 'media' : 'none' });
							}
						})
					)
				)
			)
		);
	}
);
